import { applyMiddleware, createStore, compose } from 'redux'
import createSagaMiddleware from 'redux-saga'
import createLogger from 'redux-logger'
import reduxCatch from 'redux-catch'
import { browserHistory } from 'react-router'
import { routerMiddleware } from 'react-router-redux'

import { isDebugSet } from 'utils/debug'
import Raven from 'utils/raven'
import rootReducer from 'reducers'
import rootSaga from 'sagas'
import analyticsMiddleware from 'middlewares/analytics'

const errorHandler = (err, getState) => {
  const state = getState()
  if (isDebugSet(state)) {
    console.log("Store error", err) // eslint-disable-line no-console
  }
  Raven.captureException(err, state)
}

export default (initialState) => {
  const sagaMiddleware = createSagaMiddleware()
  const middleware = [
    reduxCatch(errorHandler),
    sagaMiddleware,
    routerMiddleware(browserHistory),
    analyticsMiddleware,
    isDebugSet(initialState) && createLogger({ collapsed: true }),
  ].filter(Boolean)

  const store = createStore(
    rootReducer,
    initialState,
    compose(
      applyMiddleware(...middleware),
      (isDebugSet(initialState) && window.devToolsExtension) ? window.devToolsExtension() : f => f
    )
  )

  sagaMiddleware.run(rootSaga)

  return store
}



/** WEBPACK FOOTER **
 ** ./src/store/configure-store.js
 **/